export const DefaultActions = [
    {
        key: "EDIT",
        icon: "clarity:edit-line",
        ttLabel: "Edit",
        targetId: "edit",
        handler: "EDIT",
        iconWidth: 16
    },
    {
        key: "DELETE",
        icon: "fluent:delete-16-regular",
        ttLabel: "Delete",
        targetId: "delete",
        handler: "DELETE",
        iconWidth: 16
    },
    {
        key: "VIEW",
        icon: "mdi:eye",
        ttLabel: "View",
        targetId: "view",
        handler: "VIEW",
        iconWidth: 16
    }
];